import { Button } from '@toasttab/shared/src/components'
import ImageResolutions from '@toasttab/shared/src/components/atoms/Image/ImageResolutions'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import React from 'react'
import AppleAppStoreButton from '@toasttab/shared/src/assets/svg/badges/apple_btn.svg'
import GooglePlayButton from '@toasttab/shared/src/assets/svg/badges/googleplay_btn.svg'
import useIsClient from '@toasttab/shared/src/hooks/useIsClient'

type CardProps = {
  title: string
  description: any
  image: any
  buttons: []
}

const Card: React.FC<CardProps> = ({ title, description, image, buttons }) => {
  const isClient = useIsClient()

  const imageResolutions: any = [
    {
      desktop: [
        {
          extension: 'png',
          url: image.desktop.file.url,
          title: image.desktop.title
        }
      ],
      tablet: [
        {
          extension: 'png',
          url: image.tablet.file.url,
          title: image.tablet.title
        }
      ],
      mobile: [
        {
          extension: 'png',
          url: image.mobile.file.url,
          title: image.mobile.title
        }
      ]
    }
  ]
  // bg-primary-yellow-25
  return (
    <div className="bg-gray-0 flex flex-col md:flex-row lg:flex-row rounded-lg shadow-sm pl-4 min-w-[200px]">
      <div className="md:flex-[3] lg:flex-[3] pr-4 md:pr-3">
        <div className="text-center pt-12 lg:pt-12 md:text-left md:pb-0 md:pl-4">
          <Typography as="h4" variation="h4" classes="text-default mb-2" allowHtml={true}>
            {title}
          </Typography>
          <div
            className="text-gray-100 pb-3 mb-2"
            dangerouslySetInnerHTML={{ __html: description.childMarkdownRemark.html }}
          />
          <div className="flex space-x-4 pb-6 justify-center md:justify-start">
            {buttons.map((button: any, index: number) => {
              if (button.icon === 'Apple App Download')
                return (
                  <a href={button.url} target="_blank" rel="noopener noreferrer" key={index}>
                    <img src={AppleAppStoreButton} />
                  </a>
                )
              if (button.icon === 'Google Play Download')
                return (
                  <a href={button.url} target="_blank" rel="noopener noreferrer" key={index}>
                    <img src={GooglePlayButton} />
                  </a>
                )
              return (
                <Button
                  href={button.url}
                  classes={`mt-2 !max-w-[188px]`}
                  fullwidth={false}
                  size={`medium`}
                  variation={`primary`}
                  key={index}
                >
                  {button.label}
                </Button>
              )
            })}
          </div>
        </div>
      </div>
      <div className="md:flex-[2] lg:flex-[2] mt-0 md:mt-4 lg:mt-0 lg:ml-4">
        {imageResolutions && (
          <ImageResolutions
            imageAlt={imageResolutions[0].desktop[0].title ? imageResolutions[0].desktop[0].title : null}
            images={{ imageResolutions }}
            classes={`object-cover`}
          />
        )}
      </div>
    </div>
  )
}

export default Card
